import Link from 'next/link'
import React, { ReactElement } from 'react'
import s from './ShishCard.module.scss'
import { getFastlyUrl } from '@corratech/pylot-image'
import cn from 'classnames'

type WidgetConfiguration = {
    widgetConfiguration: { [key: string]: string }
    children?: ReactElement[]
    childLength?: number
}
const ShishaCard = (props: WidgetConfiguration) => {
    const {
        widgetConfiguration: {
            buttonlink,
            buttontext,
            content,
            heading,
            image,
            'image-fastly-param': imageFastlyParam
        },
        children,
        childLength
    } = props

    const getfastlyConfig = () => {
        if (imageFastlyParam) {
            return JSON.parse(imageFastlyParam)
        }
        if (childLength === 2) {
            return { width: 624, height: 654 }
        }
        if (childLength === 3) {
            return { width: 410, height: 580 }
        }
        if (childLength === 4) {
            return { width: 302, height: 520 }
        }
    }
    const fastlyImageUrl = getFastlyUrl({
        src: image,
        ...getfastlyConfig()
    })

    const noButton = !buttonlink && !buttontext
    return (
        <div className={cn(s.ShishaCard, 'ShishaCard')}>
            {/* eslint-disable-next-line i18next/no-literal-string */}
            <img src={fastlyImageUrl} alt="shisha card" loading="lazy" />
            <div className={cn(s.allContent, 'allContent', { noButton })}>
                <h3 className={s.cardHeader}>{heading}</h3>
                <span className={s.content}>{content}</span>
                {!noButton && (
                    <Link type="link" href={buttonlink}>
                        <span className={s.buttonLink}>{buttontext}</span>
                    </Link>
                )}
            </div>
        </div>
    )
}
export default ShishaCard
